import Statut from "./Statut";
import LivreIcon from "icons/statuts/LivreIcon";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import type { SvgIconComponent } from "@mui/icons-material";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import RestoreIcon from "@mui/icons-material/Restore";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import type { ColorPaletteKey } from "providers";

export interface StatutAssociation {
  color: ColorPaletteKey;
  label: string;
  smallLabel: string;
  icon: SvgIconComponent;
  statut: Statut;
}

const statutMap = new Map<Statut, StatutAssociation>();

const statutEnAttente: StatutAssociation = {
  color: "aTraiter",
  label: "En attente de validation",
  smallLabel: "En attente",
  icon: ErrorOutlineOutlinedIcon,
  statut: Statut.EN_ATTENTE,
};

const statutEnPreparation: StatutAssociation = {
  color: "preparation",
  label: "En préparation",
  smallLabel: "Préparation",
  icon: ErrorOutlineOutlinedIcon,
  statut: Statut.EN_PREPARATION,
};

const statutLivre: StatutAssociation = {
  color: "livre",
  label: "Livré",
  smallLabel: "Livré",
  icon: LivreIcon,
  statut: Statut.LIVRE,
};

const statutPretEnMagasin: StatutAssociation = {
  color: "success",
  label: "Prêt en magasin",
  smallLabel: "Prêt",
  icon: CheckIcon,
  statut: Statut.PRET_EN_MAGASIN,
};

const statutRefuse: StatutAssociation = {
  color: "error",
  label: "Refusé",
  smallLabel: "Refusé",
  icon: CloseIcon,
  statut: Statut.REFUSE,
};

const statutCommande: StatutAssociation = {
  color: "commande",
  label: "Commandé",
  smallLabel: "Commandé",
  icon: RestoreIcon,
  statut: Statut.COMMANDE,
};

const statutEnTransit: StatutAssociation = {
  color: "transit",
  label: "En transit",
  smallLabel: "Transit",
  icon: LocalShippingIcon,
  statut: Statut.EN_TRANSIT,
};

const statutAnnule: StatutAssociation = {
  color: "error",
  label: "Annulé",
  smallLabel: "Annulé",
  icon: CloseIcon,
  statut: Statut.ANNULE,
};

statutMap.set(Statut.EN_ATTENTE, statutEnAttente);
statutMap.set(Statut.EN_PREPARATION, statutEnPreparation);
statutMap.set(Statut.LIVRE, statutLivre);
statutMap.set(Statut.PRET_EN_MAGASIN, statutPretEnMagasin);
statutMap.set(Statut.REFUSE, statutRefuse);
statutMap.set(Statut.COMMANDE, statutCommande);
statutMap.set(Statut.EN_TRANSIT, statutEnTransit);
statutMap.set(Statut.ANNULE, statutAnnule);

const validationStatutOptions: Array<StatutAssociation> = [
  { ...statutEnPreparation, color: "success", label: "Validé", smallLabel: "Validé" },
  statutRefuse,
];

const magasinierArticleStatutOptions = [
  statutEnPreparation,
  statutCommande,
  statutEnTransit,
  statutPretEnMagasin,
  statutAnnule,
  statutLivre,
];

const unknownStatus: StatutAssociation = {
  color: "grey",
  label: "?",
  smallLabel: "?",
  icon: QuestionMarkIcon,
  statut: Statut.EN_ATTENTE,
};

export default statutMap;
export { magasinierArticleStatutOptions, validationStatutOptions, unknownStatus };
